<input
  nz-input
  class="form-control text-dark"
  [ngModel]="$safeNavigationMigration(value?.name)"
  [nzAutocomplete]="auto"
  (input)="changeCertificateSuggestions($event)"
  (ngModelChange)="setCertificate($event)"
  (focusout)="clearValue()"
/>
<nz-autocomplete nzBackfill #auto>
  @for (certificate of certificates$ | async; track certificate) {
    <nz-auto-option
      [nzValue]="certificate"
      [nzLabel]="certificate.name"
      nz-tooltip
      [nzTooltipOverlayClassName]="'dark'"
      [nzTooltipPlacement]="'bottom'"
      [nzTooltipTitle]="certificate.name"
      >{{ certificate.name }}</nz-auto-option
    >
  }
</nz-autocomplete>
